import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAsyncFn} from 'react-use';
import {getCurrentUserUseCase, logoutUseCase} from '@/compositionRoot';
import {APP_HASH, APP_TIMESTAMP, APP_VERSION} from '@/config';

export const useController = () => {
  const [user, fetchUser] = useAsyncFn(() => getCurrentUserUseCase.execute(), []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: Not necessary
  useEffect(() => {
    fetchUser();
  }, []);

  const navigate = useNavigate();
  const handleLogout = () => {
    logoutUseCase.execute();
    navigate('/');
  };

  return {
    user: user.value,
    loading: user.loading,
    app_hash: APP_HASH,
    app_version: APP_VERSION,
    app_timestamp: APP_TIMESTAMP,
    onLogout: handleLogout,
  };
};
